import script from "./AnexoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AnexoCard.vue?vue&type=script&setup=true&lang=js"

import "./AnexoCard.vue?vue&type=style&index=0&id=218d5798&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-218d5798"]])

export default __exports__